import { SET_FADER_MODE, SET_FADER_CC, SET_FADER_CHANNEL } from './actionTypes'

export const setFaderMode = (index, mode) => ({ type: SET_FADER_MODE, index: index, mode: mode });
export const setFaderCC = (index, cc) => ({ type: SET_FADER_CC, index: index, cc: cc });
export const setFaderChannel = (index, channel) => ({ type: SET_FADER_CHANNEL, index: index, channel: channel });
